import cx from 'classnames'
import PropTypes from 'prop-types'

import {BASE_CLASS, BASE_CLASS_RULER} from './settings.js'

const MediaSize = ({children, width, height, unit}) => {
  const getTextWithUnits = size => `${size} ${unit}`
  const hasHeight = Boolean(height)
  const hasWidth = Boolean(width)

  const baseClass = cx(`${BASE_CLASS}`, {
    [`${BASE_CLASS}--withHeight`]: hasHeight
  })

  return (
    <div className={baseClass}>
      <div className={`${BASE_CLASS}Children`}>
        {children}
        {hasWidth && (
          <div className={`${BASE_CLASS}ChildrenFooter`}>
            <div className={`${BASE_CLASS_RULER} ${BASE_CLASS_RULER}--horizontal`}>
              <div
                className={`${BASE_CLASS_RULER}Line ${BASE_CLASS_RULER}Line--horizontal ${BASE_CLASS_RULER}Line--left`}
              ></div>
              <span className={`${BASE_CLASS_RULER}Line-text`}>{getTextWithUnits(width)}</span>
              <div
                className={`${BASE_CLASS_RULER}Line ${BASE_CLASS_RULER}Line--horizontal ${BASE_CLASS_RULER}Line--right`}
              ></div>
            </div>
          </div>
        )}
      </div>
      {hasHeight && (
        <div className={`${BASE_CLASS_RULER} ${BASE_CLASS_RULER}--vertical`}>
          <div
            className={`${BASE_CLASS_RULER}Line ${BASE_CLASS_RULER}Line--vertical ${BASE_CLASS_RULER}Line--top`}
          ></div>
          <span className={`${BASE_CLASS_RULER}Line-text`}>{getTextWithUnits(height)}</span>
          <div
            className={`${BASE_CLASS_RULER}Line ${BASE_CLASS_RULER}Line--vertical ${BASE_CLASS_RULER}Line--bottom`}
          ></div>
        </div>
      )}
    </div>
  )
}
MediaSize.propTypes = {
  children: PropTypes.node,
  width: PropTypes.string,
  height: PropTypes.string,
  unit: PropTypes.string
}

export default MediaSize
